import { Result } from 'antd';
import { useTranslation } from 'react-i18next';
import dentalErrorIcon from 'assets/images/benefits/dental-error.svg';

const DentalCoverageError = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Result
      icon={<img src={dentalErrorIcon} />}
      title={t('benefits.error.dentalExcludeTitle')}
      subTitle={t('benefits.error.dentalExcludeMessage')}
    />
  );
};

export default DentalCoverageError;
